module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "bkt",
    attrs: {
      "id": "d7e91"
    }
  }, [_c('b', [_vm._v("REVELATION REVEALED ")]), _c('br'), _c('span', {
    staticClass: "small"
  }, [_c('i', [_vm._v("A Verse-by-Verse Study ")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e191a"
    }
  }, [_c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "au",
    attrs: {
      "id": "d7e191"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("BY DR. JACK VAN IMPE")])]), _vm._v(" "), _c('p', {
    staticClass: "default",
    attrs: {
      "id": "d7e19113"
    }
  }, [_c('br'), _c('br'), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "RevelationRevealed_0001_001",
      "id": "d14e41",
      "src": "images/RevelationRevealed_0001_001.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-347ed4b6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Impe_ISBN9781418517243_epub_c1_r1.vue
// module id = 57
// module chunks = 0